import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import store from "./redux/store";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import AuthProvider from "./contexts/authContext";
import "./styles/tailwind.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "react-query";
import * as Sentry from "@sentry/react";
import { SENTRY } from "./config/sentry";
import { scrubEvent, scrubBreadcrumb } from "./config/sentryScrub";

if (SENTRY.enabled && SENTRY.dsn) {
  Sentry.init({
    dsn: SENTRY.dsn,
    environment: SENTRY.environment,
    release: SENTRY.release,
    sendDefaultPii: false,
    tracesSampleRate: 0, // errors-only; no transactions. Replay NOT installed.
    ignoreErrors: [
      /ResizeObserver loop/i,
      "AbortError",
      "Non-Error promise rejection captured",
      /Loading chunk \d+ failed/i,
      /extension context invalidated/i,
    ],
    denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//, /^safari-extension:\/\//],
    beforeSend: scrubEvent,
    beforeBreadcrumb: scrubBreadcrumb,
  });
}

// Root-level fallback shown when a render error is caught by Sentry.ErrorBoundary.
function AppErrorFallback() {
  return (
    <div style={{ padding: 24, textAlign: "center" }}>
      <h2>Something went wrong.</h2>
      <p>The team has been notified. Please refresh the page.</p>
    </div>
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* <AuthProvider> */}
      <Provider store={store}>
        <Sentry.ErrorBoundary fallback={<AppErrorFallback />} showDialog={false}>
          <App />
        </Sentry.ErrorBoundary>
        <ToastContainer />
      </Provider>
      {/* </AuthProvider> */}
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
